"use client";

import { useEffect, useState } from "react";
import { getBotbPrizeStraplineTexts } from "@/app/common-service";
import Logo from "@/app/(general-header)/header/logo";

const WinHeader = () => {
  const [strapline, setStrapline] = useState({
    years: "",
    winners: "",
    prizes: "",
  });

  useEffect(() => {
    const abortController = new AbortController();
    getBotbPrizeStraplineTexts(abortController)
      .then(res => res.json())
      .then(res => {
        setStrapline({
          years: res.PrizeStraplineText1 || "",
          winners: res.PrizeStraplineText3 || "",
          prizes: res.PrizeStraplineText2 || "",
        });
      })
      .catch(err => {
        if (err.name !== "AbortError") console.error(err);
      });
    return () => abortController.abort();
  }, []);

  return (
    <div className="sticky top-0 z-[1003] w-full h-[56px] lg:h-[60px] backdrop-blur-[10px] bg-white border-b border-solid border-black/8">
      <div className="h-full flex items-center justify-between px-3 max-lg:gap-2 lg:px-4 lg:max-w-[1276px] mx-auto">
        <button
          onClick={() => window.history.back()}
          className="size-6 lg:size-8 flex items-center justify-center shrink-0"
          aria-label="Go back">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12L19 12M5 12L11 18M5 12L11 6"
              stroke="#28282B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="relative lg:absolute lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2">
          <Logo />
        </div>

        <div className="flex items-center gap-3 max-lg:ml-auto lg:gap-4">
          {/* Years */}
          <div className="flex items-center gap-1 lg:gap-2">
            <img src="/assets/images/win/icon-est.svg" alt="Established" className="size-4 lg:size-6 shrink-0" />
            <div className="flex flex-col gap-1">
              <span className="font-jost font-semibold text-[11px] lg:text-[13px] leading-none text-dark-1 whitespace-nowrap">
                {strapline.years}
              </span>
              <span className="font-jost lg:font-roboto font-medium lg:font-bold text-[10px] leading-none text-gray-1">
                Years
              </span>
            </div>
          </div>

          {/* Winners */}
          <div className="flex items-center gap-1 lg:gap-2">
            <img src="/assets/images/win/icon-winners.svg" alt="Winners" className="size-4 lg:size-6 shrink-0" />
            <div className="flex flex-col gap-1">
              <span className="font-jost font-semibold text-[11px] lg:text-[13px] leading-none text-dark-1 whitespace-nowrap">
                {strapline.winners}
              </span>
              <span className="font-jost lg:font-roboto font-medium lg:font-bold text-[10px] leading-none text-gray-1">
                Winners
              </span>
            </div>
          </div>

          {/* Prizes */}
          <div className="flex items-center gap-1 lg:gap-2">
            <img src="/assets/images/win/icon-prizes.svg" alt="Prizes" className="size-4 lg:size-6 shrink-0" />
            <div className="flex flex-col gap-1">
              <span className="font-jost font-semibold text-[11px] lg:text-[13px] leading-none text-dark-1 whitespace-nowrap">
                {strapline.prizes}
              </span>
              <span className="font-jost lg:font-roboto font-medium lg:font-bold text-[10px] leading-none text-gray-1">
                Prizes
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinHeader;
